import { format } from "date-fns/format";
function handleSingleDateCalendarChange(setValue, watchLabel, setDefaultMonth, date) {
    const formattedDate = format(date, 'yyyyMMdd');
    setValue(watchLabel, formattedDate);
    setDefaultMonth(date);
}
function handleDateRangeCalendarChange(setValue, watchStartLabel, watchEndLabel, setDefaultMonth, dates, options = {}) {
    if (dates?.from) {
        const startDate = format(dates.from, 'yyyyMMdd');
        setValue(watchStartLabel, startDate);
        setDefaultMonth(dates.from);
        if (options.clearEndDateOnStart) setValue(watchEndLabel, '');
    }
    if (dates?.to) {
        const endDate = format(dates.to, 'yyyyMMdd');
        setValue(watchEndLabel, endDate);
    } else if (dates?.from && !options.clearEndDateOnStart) setValue(watchEndLabel, '');
}
const isString = (value)=>'string' == typeof value;
export { handleDateRangeCalendarChange, handleSingleDateCalendarChange, isString };
